module.exports = __webpack_public_path__ + "static/img/markerLabel01.c62e2d56.png";